// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__UcoDZ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__30VLy","obliqueLine":"membershipbadge_obliqueLine__2HzcP"};